export const intlConfig = {
  as: {
    formats: {
      date: 'MMMM dd, yyyy',
    },
    social: {
      twitter: 'CornerstoneInc',
    },
    stage: {
      url: 'https://stage.cornerstoneondemand.as',
      previewUrl: 'https://project-jam--as-2581233388.gtsb.io',
      googleTagManagerId: '',
      netlify: {
        buildHookId: '5eb078bcc120478811c9c8e9',
        apiId: '8f3143a5-1e1d-41b1-af15-ee3487ebc89a',
      },
    },
    prod: {
      url: 'https://www.cornerstoneondemand.as',
      previewUrl: 'https://project-jam--as-2581233388.gtsb.io',
      googleTagManagerId: '',
    },
  },
  au: {
    formats: {
      date: 'MMMM dd, yyyy',
    },
    social: {
      twitter: 'csod_anz',
    },
    stage: {
      url: 'https://stage.cornerstoneondemand.com.au',
      previewUrl: 'https://project-jam--au-4836167653.gtsb.io',
      googleTagManagerId: 'GTM-KFQCX6',
      netlify: {
        buildHookId: '5eb0770b004346757a9dfba1',
        apiId: '5b0b8fd6-9568-4284-9dff-763467c6d477',
      },
    },
    prod: {
      url: 'https://www.cornerstoneondemand.com.au',
      previewUrl: 'https://project-jam--au-4836167653.gtsb.io',
      googleTagManagerId: 'GTM-KFQCX6',
      netlify: {
        buildHookId: '5ef3b0d96a2dc0019e4c6409',
        apiId: 'fd0bfcb6-df39-4325-bd19-824fdb04040b',
      },
    },
  },
  de: {
    formats: {
      date: 'MMMM dd, yyyy',
    },
    social: {
      twitter: 'csod_de',
    },
    stage: {
      url: 'https://stage.cornerstoneondemand.de',
      googleTagManagerId: 'GTM-TFGVMB',
      netlify: {
        buildHookId: '5eb07bbe0b5586024b9a8cf7',
        apiId: '7dc0494b-34d1-4d60-a176-8fde3e2d9ce7',
      },
    },
    prod: {
      url: 'https://www.cornerstoneondemand.de',
      previewUrl: 'https://project-jam--de-1364158563.gtsb.io',
      googleTagManagerId: 'GTM-TFGVMB',
      netlify: {
        buildHookId: '5eb066ac15a72597dee88225',
        apiId: '782f274b-5cdf-481e-baab-612ef5596756',
      },
    },
  },
  es: {
    formats: {
      date: 'MMMM dd, yyyy',
    },
    social: {
      twitter: 'csod_es',
    },
    stage: {
      url: 'https://stage.cornerstoneondemand.es',
      googleTagManagerId: 'GTM-MWVLMH',
      netlify: {
        buildHookId: '5eb07bcbece4a8fec8eeed8f',
        apiId: '0250d604-0617-432f-8992-de059cd37009',
      },
    },
    prod: {
      url: 'https://www.cornerstoneondemand.es',
      previewUrl: 'https://project-jam--es-8816227731.gtsb.io',
      googleTagManagerId: 'GTM-MWVLMH',
      netlify: {
        buildHookId: '5eb0659b1a47a070851031df',
        apiId: 'c7269d58-f8fe-4d24-bfc3-01ccc1f641f4',
      },
    },
  },
  fr: {
    formats: {
      date: 'MMMM dd, yyyy',
    },
    social: {
      twitter: 'csod_fr',
    },
    stage: {
      url: 'https://stage.cornerstoneondemand.fr',
      googleTagManagerId: 'GTM-K828VF',
      netlify: {
        buildHookId: '5eb07bd798c8baeaec20ca54',
        apiId: '6298f105-5940-4639-b587-8e24fccdf408',
      },
    },
    prod: {
      url: 'https://www.cornerstoneondemand.fr',
      previewUrl: 'https://project-jam--fr-1424714753.gtsb.io',
      googleTagManagerId: 'GTM-K828VF',
      netlify: {
        buildHookId: '5eb0668ecad4a287389cd6f7',
        apiId: '013ecfde-c8da-4064-a129-67227c078cd0',
      },
    },
  },
  it: {
    formats: {
      date: 'MMMM dd, yyyy',
    },
    social: {
      twitter: 'csod_it',
    },
    stage: {
      url: 'https://stage.cornerstoneondemand.it',
      googleTagManagerId: 'GTM-5TRVXZ',
      netlify: {
        buildHookId: '5eb07d35ece4a803abeeeecb',
        apiId: 'dc19ff87-524d-448b-9501-37e042925249',
      },
    },
    prod: {
      url: 'https://www.cornerstoneondemand.it',
      previewUrl: 'https://project-jam--it-6278554137.gtsb.io',
      googleTagManagerId: 'GTM-5TRVXZ',
      netlify: {
        buildHookId: '5eb0669d49322f7f64c1616a',
        apiId: 'f5ef9325-445f-42a6-950a-f9adc891f057',
      },
    },
  },
  jp: {
    formats: {
      date: 'MMMM dd, yyyy',
    },
    social: {
      twitter: 'CornerstoneInc',
    },
    stage: {
      url: 'https://stage.cornerstoneondemand.jp',
      googleTagManagerId: 'GTM-P4XGFM',
      netlify: {
        buildHookId: '5eb0773798c8ba863d20ca2c',
        apiId: 'f50945e3-9eb8-472b-a456-67cbf66f5db5',
      },
    },
    prod: {
      url: 'https://www.cornerstoneondemand.jp',
      previewUrl: 'https://project-jam--jp-8334142757.gtsb.io',
      googleTagManagerId: 'GTM-P4XGFM',
      netlify: {
        buildHookId: '5ebf09ecff645841fe19553b',
        apiId: 'ba4fe73f-756f-47b5-81eb-8688d115dcc3',
      },
    },
  },
  kr: {
    formats: {
      date: 'MMMM dd, yyyy',
    },
    social: {
      twitter: 'CornerstoneInc',
    },
    stage: {
      url: 'https://stage.cornerstoneondemand.kr',
      googleTagManagerId: 'GTM-MWLF6SK',
      netlify: {
        buildHookId: '5eb079020043468f939dfeb5',
        apiId: '54c8771a-9aaa-4f9f-a176-7daa336d09b8',
      },
    },
    prod: {
      url: 'https://www.cornerstoneondemand.kr',
      googleTagManagerId: 'GTM-MWLF6SK',
    },
  },
  uk: {
    formats: {
      date: 'MMMM dd, yyyy',
    },
    social: {
      twitter: 'csodemea',
    },
    stage: {
      url: 'https://stage.cornerstoneondemand.co.uk',
      googleTagManagerId: 'GTM-NHG7P8S',
      netlify: {
        buildHookId: '5eb07bb12c0536005e8e390f',
        apiId: '88f2a4e4-711a-402c-912a-c28aea4cd994',
      },
    },
    prod: {
      url: 'https://www.cornerstoneondemand.co.uk',
      previewUrl: 'https://project-jam--uk-2843441415.gtsb.io',
      googleTagManagerId: 'GTM-WNZ99G',
      netlify: {
        buildHookId: '5eb0653c15a72589f7e881f0',
        apiId: '8a2d680d-5474-4c18-88fa-aba4d8afbe81',
      },
    },
  },
  us: {
    formats: {
      date: 'MMMM dd, yyyy',
    },
    social: {
      twitter: 'CornerstoneInc',
    },
    dev: {
      url: 'https://dev.cornerstoneondemand.com',
      previewUrl: 'https://project-jam--us--dev-3378884185.gtsb.io',
      googleTagManagerId: 'GTM-MZL73T',
      netlify: {
        buildHookId: '5d890bbc4857cec959572923',
        apiId: 'a07e6fc9-f869-4660-a37c-dc73698d2ce6',
      },
    },
    stage: {
      url: 'https://www.stage.cornerstoneondemand.com',
      googleTagManagerId: 'GTM-MZL73T',
      netlify: {
        buildHookId: '5d83f49db708a4ad5b59641e',
        apiId: '2c6079fc-5c5f-407a-a292-56f833ad0594',
      },
    },
    prod: {
      url: 'https://www.cornerstoneondemand.com',
      previewUrl: 'https://project-jam--us-5526145214.gtsb.io',
      googleTagManagerId: 'GTM-TSBK8D',
      netlify: {
        buildHookId: '5cd482a60d84abd10fee77e9',
        apiId: '66dde72d-6d43-497e-9cde-36c7a12d9556',
        title: 'Build Prod',
        name: 'csod-us-prod',
      },
    },
  },
};

export const intlCodes = Object.keys(intlConfig);

export const datasetEnvs = ['dev', 'stage', 'prod'];

export const getLocale = (dataset) => {
  // returns INTL_ENV var value when it exists
  if (process.env.INTL_ENV) return process.env.INTL_ENV;
  // checks if an intl dataset is being used
  // helpful when running an intl dataset locally
  // where there is no INTL_ENV var
  if (intlConfig[dataset.substring(0, 2)]) return dataset.substring(0, 2);
  // default locale is us
  return 'us';
};

export const getEnvironment = (dataset) => {
  const env = dataset.substring(4);
  return datasetEnvs.includes(env) ? env : 'dev';
};

export const getAlgoliaIndexName = (dataset) => {
  const datasetParts = dataset.split('--');
  return intlCodes.includes(datasetParts[0])
    && datasetEnvs.includes(datasetParts[1])
    ? dataset
    : 'us--dev';
};

export const configForDataset = (dataset) => {
  const datasetLocale = getLocale(dataset);
  const datasetEnv = dataset.substring(4);
  const localeConfig = intlConfig[datasetLocale] || intlConfig.us;
  const envConfig = (localeConfig && localeConfig[datasetEnv]) || localeConfig.dev;

  const {
    dev, stage, prod, ...localeWithoutEnvConfig
  } = localeConfig;
  return { ...envConfig, ...localeWithoutEnvConfig };
};

export const getSiteUrl = (dataset) => {
  const config = configForDataset(dataset);
  if (process.env.NETLIFY) {
    return (process.env.CONTEXT === 'branch-deploy') ? process.env.DEPLOY_PRIME_URL : config.url;
  }
  if (process.env.GATSBY_PREVIEW_ENV) {
    return config.previewUrl;
  }
  return 'http://localhost:8000';
};

export const productionUrls = () => intlCodes.map(intlCode => intlConfig[intlCode].prod.url);

export const areWeOnProduction = (dataset) => {
  const currentUrl = getSiteUrl(dataset);
  return productionUrls().some(prodUrl => currentUrl.includes(prodUrl));
};

export default intlConfig;
